<template>
  <div class='table-box'>
    <global-tag>

    </global-tag>
    <div class='table_title'>
      <div class='btn_group'>
        <el-button type='primary' class='button downOutBtns' @click='createExcel'>下载模版
        </el-button>
        <div style='display: none'>
          <input @change='fileChange' id='speechUpload' type='file' />
        </div>
        <label for='speechUpload' class='labelImportBtn inDwonBtns'>
          <span>导入</span>
        </label>
        <!-- <el-button-group>
              <el-button
                  type="success"
                  icon="iconfont icon-xinzeng"
                  @click="handleTableForm('新增', 'add')"
                  >新增</el-button
              >
          </el-button-group> -->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  inject: ['reload'], //注入
  data() {
    return {
    }
  },
  created() {
    
  },
  methods: {
    createExcel(data) {
      this.request2({
        url: "/jjyl/admin/homePage/bigScreen/info/downLoadTemplate",
        data: {
          pageNo: 1,
          pageSize: 100,
        },
        method: "POST",
        responseType: "blob",
      }).then((res) => {
        if (res) {
          const blob = new Blob([res], {
            type: "application/vnd.ms-excel",
          })
          const fileName = "首页数据.xls"
          const linkNode = document.createElement("a")
          linkNode.download = fileName //a标签的download属性规定下载文件的名称
          linkNode.style.display = "none"
          linkNode.href = URL.createObjectURL(blob) //生成一个Blob URL
          document.body.appendChild(linkNode)
          linkNode.click() //模拟在按钮上的一次鼠标单击
          URL.revokeObjectURL(linkNode.href) // 释放URL 对象
          document.body.removeChild(linkNode)
          this.$message.success("下载成功")
        }
      })
    },

    // 导入
    async fileChange(event) {
      console.log(event)
      const file = event.target.files[0]
      console.log(file)
      const personType = '1'
      let config = {
        headers: { 'Content-Type': 'multipart/form-data' }
      }
      let formData = new FormData()
      console.log(formData)
      formData.append('file', file)
      let result = await this.$http.post(
        'jjyl/admin/homePage/bigScreen/info/importData',
        formData,
        config
      )
      // 清空文件
      const fileEle = document.getElementById('speechUpload')
      fileEle.value = ''
      if (result.code == 200) {
        this.$message.success(result.message)
      } else {
        this.$message.warning(result.message)
      }
    },

  }
}
</script>
<style lang='less' scoped>
/deep/ .table_title {
  margin-top: 20px !important;
}

.searchBox {
  display: flex;

  .content {
    flex: 1;
  }
}

/deep/ .btn_group {
  margin-top: 0px !important;
}

.button {
  margin-bottom: 4px;
}

.operBtn {
  cursor: pointer;
  margin-left: 10px;
}
</style>